module.exports = __webpack_public_path__ + "img/left-arrow-selected.42904db7.svg";